import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button, Icon } from 'semantic-ui-react'
import Upload, { UploadModal } from '~/file/upload'
import { getFileType, formatBytes, getAcceptedType } from '~/file/utils'
import { resetForm } from '~/form/actions'
import ArticleCreate from '~/article/views/create'
import ArticleEdit from '~/article/views/edit'
import BurnCaptions from './burnCaptions'
import MaterialPreview from './preview'
import CopyAndArchive from './copyArticle'
import moment from 'moment'

function getItemComments(group, item_id) {
  return group.reduce((list, a) => {
    let comment = a.getIn(['data', 'comments', item_id], false)
    if (!comment || a.getIn(['data', 'status'], 'pending') === 'approved') return list
    let title = Map.isMap(a.get('person'))
      ? `Haastateltava: ${a.getIn(['person', 'data', 'name'])}`
      : `Asiakas: ${a.getIn(['contact', 'name'])}`
    return list.push(Map({ title, comment }))
  }, List())
}

export default class Materials extends Component {
  state = {
    showArchived: false,
    articleCreate: false,
    articleEdit: false,
  }

  handleFileUpload = files => {
    let { materials, updateMaterials } = this.props
    let events = [
      {
        type: 'INTERVIEW_UPLOADED_MATERIALS',
        variables: {
          files: files.map(f => f.title || f.filename),
        },
      },
    ]

    files = files.map(file => {
      let { id, archived = false } = file
      return {
        id,
        type: 'file',
        archived,
        file,
      }
    })

    updateMaterials(materials.concat(fromJS(files)), events)
  }

  render() {
    let { showArchived, articleCreate, articleEdit } = this.state
    let { materials, updateMaterials, activeApprovalGroup, interview, dispatch } = this.props

    let tabs = [
      {
        title: 'Tiedostot',
        archived: false,
      },
      {
        title: 'Näytä arkistoidut',
        archived: true,
      },
    ]

    let filteredMaterials = materials.filter(f => f.get('archived', false) === showArchived)

    let videos = filteredMaterials.filter(f => f.getIn(['file', 'meta', 'type'], '').startsWith('video'))

    let groups = [
      {
        title: 'Videot',
        items: videos,
        materialType: 'video',
      },
      {
        title: 'Tekstitykset',
        items: filteredMaterials.filter(f => f.getIn(['file', 'meta', 'mime'], '') === 'application/x-subrip'),
        burnAction: true,
        materialType: 'subtitle',
      },
      {
        title: 'Kuvat',
        items: filteredMaterials.filter(f => f.getIn(['file', 'meta', 'type'], '').startsWith('image')),
        materialType: 'image',
      },
      {
        title: 'Artikkelit',
        items: filteredMaterials.filter(f => f.get('type', '') === 'article'),
        materialType: 'article',
      },
    ]

    return (
      <div className="materials">
        <div className="materials-tabs">
          {tabs.map(({ title, archived }, key) => {
            let classes = ['materials-tab']
            if (archived === showArchived) classes.push('materials-tab--active')

            return (
              <button
                className={classes.join(' ')}
                key={key}
                onClick={e => e.preventDefault() & this.setState({ showArchived: archived })}>
                {title}
              </button>
            )
          })}
        </div>
        <div className="materials-list">
          {filteredMaterials.size ? (
            groups.map(({ title, items, burnAction = false, materialType }, key) =>
              items.size ? (
                <div className="materials-list-group" key={key}>
                  <div className="materials-list-group-title">{title}</div>
                  <div className="materials-list-group-items">
                    {items.map((i, key) => {
                      let f = i.get('file', Map())

                      let type = i.get('type')
                      let comments = getItemComments(activeApprovalGroup, i.get('id'))

                      return (
                        <div className="materials-list-item" key={key}>
                          <div className="materials-list-item-name">
                            <a
                              href={f.get('url')}
                              target="_blank"
                              onClick={e => {
                                if (i.get('type') !== 'article') return

                                e.preventDefault()
                                this.setState({ articleEdit: i.get('id') })
                              }}>
                              {f.get('filename', f.get('title'))}
                            </a>
                          </div>
                          <div className="materials-list-item-info">
                            <div>
                              {f.getIn(['meta', 'size']) ? <span>{formatBytes(f.getIn(['meta', 'size']))}</span> : null}
                              {f.get('created_at') ? (
                                <span>{moment(f.get('created_at')).format('DD.MM.YYYY - HH.mm')}</span>
                              ) : null}
                              {burnAction ? <BurnCaptions videos={videos} caption={i} interview={interview} /> : null}
                              {comments.size ? (
                                <span className="materials-list-item-commented">
                                  <span className="materials-list-item-commented-status">
                                    <Icon name="warning" /> Kommentoitu ({comments.size})
                                  </span>
                                  <div className="materials-list-item-commented-content">
                                    {comments.map((c, k) => (
                                      <div key={k}>
                                        <b>{c.get('title')}</b>
                                        {c.get('comment')}
                                      </div>
                                    ))}{' '}
                                  </div>
                                </span>
                              ) : null}
                              {type === 'article' ? (
                                <CopyAndArchive
                                  id={i.get('id')}
                                  materials={materials}
                                  updateMaterials={updateMaterials}
                                />
                              ) : null}
                              <MaterialPreview file={f} type={materialType} />
                            </div>
                            <div>
                              <button
                                onClick={e => {
                                  e.preventDefault()
                                  let events = [
                                    {
                                      type: i.get('archived')
                                        ? 'INTERVIEW_MATERIAL_UNARCHIVE'
                                        : 'INTERVIEW_MATERIAL_ARCHIVE',
                                      variables: {
                                        filename: f.get('filename', f.get('title')),
                                      },
                                    },
                                  ]
                                  updateMaterials(
                                    materials.map(f =>
                                      f.get('id') === i.get('id')
                                        ? f.set('archived', i.get('archived', false) === false)
                                        : f
                                    ),
                                    events
                                  )
                                }}>
                                {i.get('archived') ? 'Palauta aineisto' : 'Arkistoi aineisto'}
                              </button>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              ) : null
            )
          ) : (
            <div className="materials-list-empty">Aineistoja ei ole ladattu.</div>
          )}
        </div>
        <div className="materials-action">
          <UploadModal
            text="Lataa tiedostoja"
            onUploadSuccess={this.handleFileUpload}
            multiple
            selectOnMount
            access="public"
            context={{
              interviewId: interview.get('id'),
              material: true,
            }}
          />
          <Button
            color="blue"
            size="tiny"
            onClick={e => e.preventDefault() & this.setState({ articleCreate: true })}
            content="Lisää artikkeli"
            icon="plus"
          />
        </div>
        {articleCreate ? (
          <ArticleCreate
            onCreate={article => {
              delete article.content
              article.type = 'article'

              let material = {
                id: article.id,
                type: 'article',
                archived: false,
                file: article,
              }

              let events = [
                {
                  type: 'INTERVIEW_CREATE_ARTICLE',
                  variables: {
                    title: article.title,
                  },
                },
              ]
              updateMaterials(materials.push(fromJS(material)), events)
              dispatch(resetForm('article-form'))
              this.setState({ articleCreate: false })
            }}
            onClose={() => this.setState({ articleCreate: false })}
          />
        ) : null}
        {articleEdit ? (
          <ArticleEdit
            articleId={articleEdit}
            onSubmit={article => {
              delete article.content

              let events = [
                {
                  type: 'INTERVIEW_UPDATE_ARTICLE',
                  variables: {
                    title: article.title,
                  },
                },
              ]

              dispatch(resetForm('article-form'))
              updateMaterials(
                materials.map(i =>
                  i.get('id') === article.id ? i.set('file', i.get('file', Map()).merge(fromJS(article))) : i
                ),
                events
              )
              this.setState({ articleEdit: false })
            }}
            onClose={() => this.setState({ articleEdit: false })}
          />
        ) : null}
      </div>
    )
  }
}
